import React from 'react'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
import MUIDataTable from 'mui-datatables'

class UploadsAdd extends React.Component {
  state = {
    image: '',
    text: '',
    imagesList: [],
  }

  componentDidMount() {
    this.getUploadedImages()
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  handleChangeImage = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] })
    this.setState({ img: URL.createObjectURL(e.target.files[0]) })
  }

  uploadImage = () => {
    if (!this.state.image) {
      Swal.fire('Image Required!', '', 'error')
      return
    }

    const formData = new FormData()
    formData.append('image', this.state.image, 'your_original_filename.jpeg')

    this.setState({ isData: true })

    axios
      .post(Constant.getAPI() + '/admin/upload-image', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        this.setState({ isData: false })
        if (res.status) {
          this.setState({
            text: Constant.getImage() + res?.data?.data?.img_path,
          })
          Swal.fire({
            title: 'Image uploaded successfully!',
            text: `${Constant.getImage() + res?.data?.data?.img_path}`,
            icon: 'success',
          })
        }
        window.location.href = '#/uploads'
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.onClearData()
        this.getUploadedImages()
      })
  }

  onSaveData = () => {
    this.uploadImage()
  }

  onClearData = () => {
    this.setState(
      {
        image: '',
        img: '',
      },
      () => {
        this.image_input.value = null
      }
    )
    this.getUploadedImages()
  }

  getUploadedImages = async () => {
    await axios
      .get(Constant.getAPI() + '/admin/uploaded-images', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            imagesList: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  deleteImage = (name) => {
    Swal.fire({
      title: 'Are you sure to delete this image?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        axios
          .delete(Constant.getAPI() + `/admin/delete-image/${name}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
          })
          .then(() => {
            Swal.fire({
              title: 'Image Deleted Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
            this.getUploadedImages()
          })
          .catch((err) => {
            if (err?.response?.status === 401) {
              Constant.getAuthLogout()
            } else {
              Swal.fire({
                title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                icon: 'error',
                text: '',
                type: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
              })
            }
          })
      }
    })
  }

  render() {
    const columns = [
      {
        name: 'name',
        label: 'Image',
        options: {
          customBodyRender: (value) => {
            return (
              <>
                <a
                  href={Constant.getImage() + '/public/images/pushwoosh/' + value}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={Constant.getImage() + '/public/images/pushwoosh/' + value}
                    height="50"
                    alt="img"
                    onError={(event) => {
                      event.currentTarget.src = './assets/images/no_image.png'
                    }}
                  />
                </a>
              </>
            )
          },
        },
      },
      {
        name: 'name',
        label: 'Image Link',
        options: {
          customBodyRender: (value) => {
            return <span>{Constant.getImage() + '/public/images/pushwoosh/' + value}</span>
          },
        },
      },
      {
        name: 'name',
        label: 'View',
        options: {
          customBodyRender: (value) => {
            return (
              <>
                <a
                  rel="noreferrer"
                  href={Constant.getImage() + '/public/images/pushwoosh/' + value}
                  target="_blank"
                >
                  <i className="f-22 icofont icofont-eye text-dark"></i>
                </a>
              </>
            )
          },
        },
      },
      {
        name: 'name',
        label: 'Actions',
        options: {
          sort: true,
          customBodyRender: (name) => {
            return (
              <div>
                <span
                  onClick={this.deleteImage.bind(this, name)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filter: false,
      download: false,
      search: false,
      viewColumns: false,
      print: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>Uploads(Temp Images)</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <div className="form-group row">
                          <label className="col-3 col-form-label">Upload Image</label>
                          <div className="col-9">
                            <input
                              type="file"
                              className="w-100"
                              accept="image/*"
                              name="image"
                              id="img"
                              onChange={this.handleChangeImage}
                              ref={(ref) => (this.image_input = ref)}
                            />
                            <img
                              style={{ marginTop: 10 }}
                              height="200px"
                              src={this.state?.img || './assets/images/no_image.png'}
                              alt="img"
                              onError={(event) => {
                                event.currentTarget.src = './assets/images/no_image.png'
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-6">
                        <div style={{ color: 'red', fontWeight: 'bold', textAlign: 'left', fontSize: '16px' }}>
                          Attention: Don't forget to copy the image link!
                        </div>
                      </div>
                      <div className="col-6 float-right">
                        <div style={{ float: 'right' }}>
                          {this.state.isData ? (
                            <button
                              className="btn btn-grd-disabled mr-2"
                              disabled
                            >
                              Saving...!
                            </button>
                          ) : (
                            <button
                              onClick={this.onSaveData}
                              className="btn btn-grd-disabled mr-2"
                            >
                              <i className="icofont icofont-save"></i> Save
                            </button>
                          )}
                          <button
                            onClick={this.onClearData}
                            className="btn btn-grd-disabled mr-2"
                          >
                            <i className=""></i> Clear
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="dt-responsive table-responsive">
                    <MUIDataTable
                      className="table-responsive"
                      data={this.state.imagesList}
                      columns={columns}
                      options={options}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default UploadsAdd
